import type { Article } from './types';
import article01 from './article-01';
import article02 from './article-02';
import article03 from './article-03';
import article04 from './article-04';
import article05 from './article-05';
import article06 from './article-06';
import article07 from './article-07';
import article08 from './article-08';
import article09 from './article-09';
import article10 from './article-10';
import article11 from './article-11';

export const articles: Article[] = [
  article01,
  article02,
  article03,
  article04,
  article05,
  article06,
  article07,
  article08,
  article09,
  article10,
  article11,
].sort((a, b) => a.order - b.order);

export function getArticle(slug: string): Article | undefined {
  return articles.find((a) => a.slug === slug);
}

export type { Article, ArticleLocalized, ArticleSection } from './types';